<template>
  <div style="background: #f9f9f9" class="adaptiveMobileDesignDetails">
    <div class="details flex designRequirement">
      <div class="details_left">
        <p class="currentPosition">
			<span>当前位置：</span>
			<el-breadcrumb separator=">">
			  <el-breadcrumb-item :to="{ path: '/design' }">设计市场</el-breadcrumb-item>
			  <el-breadcrumb-item v-if="this.type=='PRODUCT'">成果详情</el-breadcrumb-item>
			  <el-breadcrumb-item v-else>平面设计详情</el-breadcrumb-item>
			</el-breadcrumb>
          <!-- 当前位置：设计市场><span style="color:#157efb" v-if="this.type=='PRODUCT'">成果详情</span><span style="color:#157efb" v-else>平面设计详情</span> -->
        </p>
        <div class="left_top" style="padding-bottom:0px">
          <div class="left_top_title flex">
            <div class="titleContent">
              <p class="designTitle">
                <span class="designTop">{{product.productName}}</span
                >
              </p>
              <div class="budget flex">
                <div class="budgetLeft">
                  <p>上传时间：<span>{{product.createDate}}</span></p>
                </div>

              </div>
            </div>
           <div class="left_top_mess flex">
            <div class="left_top_share flex">
              <p>
                <i class="el-icon-view" style="font-size: 22px;"></i>
                <span style="font-size: 17px;line-height: 22px">{{product.accessNum}}</span>
              </p>
              <!-- <p class="el-icon-view">{{product.accessNum}}</p> -->
              <p class="flex share">
                <share :config="config" class="shareHover"></share>
              </p>

            </div>
          </div>
          </div>

        </div>
        <!-- 基本信息 -->
        <div class="left_center">
          <div class="center_mess">
            <!--<p class="center_mess_title">成果详情</p>-->
            <div class="center_mess_box center_mess_box_img ql-editor vHtmlMess" v-html="product.remark"></div>

          </div>

        </div>

      </div>
      <div class="details_right">
        <div class="right_mess">
          <div class="firstImg">
              <img v-if="user.headUrl" :src="user.headUrl" alt="" />
              <!-- <img v-else src="../../assets/设计市场/default.jpg" alt="" /> -->
              <img v-else src="../../assets/users.png" alt="" />
          </div>

          <p class="right_mess_names">
            <span v-text="user.name"></span>
            <img v-for="(item,index) in designerLevels" src="../../assets/模型库/designIcon.png" style="width:55px;height:20px" :src="item.levelIconUrl" title="" :title="item.name"
                 >
            <span></span>
          </p>

          <button @click="startChat">立即联系</button>
        </div>
        <div class="recommendedRequirements">
          <div class="requirementsTitle">
            <div class="name">推荐作品</div>
            <div class="refresh" @click="getProductList">
              <a
                href="javascript:void(0)"
                style="color: #157efb; font-size: 14px"
                >换一批</a
              >
              <i class="el-icon-refresh-right"></i>
            </div>
          </div>
          <div class="requirementItem" v-for="(items, index) in productList">
            <div style="margin-bottom:10px" @click="getDetailMessage(items.uuid)">
                <img :src="items.imgUrl" alt="" style="width:100%;">
            </div>
            <h4 class="rqTitle" style="width:340px" @click="getDetailMessage(items.uuid)">
              {{items.productName}}
            </h4>
            <ul class="rqDetail">
              <li>
                <div class="detailTitle">上传时间：</div>
                <div class="detailContent">{{items.createDate}}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--聊天窗口-->
    <chat-dialog ref="chatDialogRef"></chat-dialog>
  </div>
</template>

<script>
  import {
    getUserInfo,
    getProductDetail,
    getRongCloudUser,
    queryProductList,
    addProductAccessNum,
    getDesignLevel,
    designerByUserId,
  } from "../../utils/interface";
  import { mapState, mapMutations } from "vuex";
  import chatDialog from "../chat/chatDialog";
export default {
  //   需求详情
  name: "designDetails",
  components: {
    chatDialog
  },
  data() {
    return {
      config: {
        url: window.location.href,
        disabled: ['douban', 'linkedin', 'diandian', 'qq', 'qzone', 'tencent', 'google', 'twitter', 'tencent', 'weibo']
      },
      product:{},
      user: {},
      productList: [],
      type:'',
      pNo: 1,
      pSize: 4,
      designerLevels: [],
    };
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
      isLogin: "isLogin",
    }),
  },
  created() {
    this.type = this.$route.query.type;
    getProductDetail(this.$route.query.uuid).then((res) => {
      if(res){
        this.product = res;
        designerByUserId(res.creatorUuid).then((res) => {
          if (res != null && res.status == 'PASS') {
            getDesignLevel({
              designerUuid : res.uuid
            }).then((res) => {
              this.designerLevels = res;
            });
          }
        });
        getUserInfo(res.creatorUuid).then((res) => {
          this.user = res;
          this.getProductList();
        });
      }
    });
    addProductAccessNum(this.$route.query.uuid).then((res) => {
      if(res){
        console.log(res.message);
      }
    });
  },
  methods: {
    getProductList(){
      queryProductList({
        userUuid : this.user.uuid,
        status: "RELEASED",
        current: this.pNo,
        pageSize: this.pSize,
        productType: this.type,
      }).then((res) => {
        let pages = 0;
        if (res != null && res.total > 0) {
          pages = Math.ceil(res.total / 4);
          if (this.pNo <= pages - 1) {
            this.pNo = this.pNo + 1;
          } else {
            this.pNo = 1;
          }
        }

        if (res != null && res.list != null && res.list.length > 0) {
          this.productList = res.list;
          // console.log(this.productList)
        }
      });
    },
    startChat() {
      let targetUserId = this.user.uuid;
      if (this.isLogin) {
        let user = this.$store.state.isUsermessage;
        getRongCloudUser(targetUserId).then(res=> {
          console.log('targetUserId-------' + targetUserId);
          console.log(res);
          this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
        });
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    getDetailMessage(uuid) {
      let routeData = this.$router.resolve({
        name: "productWork",
        query: { uuid: uuid, type: this.type },
      });
      window.open(routeData.href, "_blank");
    },
  },

};
</script>

<style scoped lang="less">
@import "../../assets/dist/css/share.min.css";

.wechat-qrcode{
  display: none !important;
}
.icon-wechat:before {
    content: "\F09A"!important;
}



.designRequirement {
  .currentPosition {
    font-size: 14px;
    color: #808080;
    padding-bottom: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
	display: flex;
	align-items: center;
    span {
      color: #808080;
    }
  }
  .titleContent {
    .designTitle {
      span {
        font-size: 12px;
        font-weight: 400;
        color: #c9c9c9;
        padding-left: 15px;
        vertical-align: middle;
      }
      .designTop{
         font-size: 18px;
        font-weight: bold;
        color: #262626;
        letter-spacing: 1px;
        padding: 0;
        max-width: 624px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
    }
    .budget {
      padding: 29px 0 34px;
      font-size: 12px;
      color: #5a5a5a;
      align-items: center;
      .budgetLeft {
        p {
          margin-right: 21px;
        }
      }
    }
  }
  .left_top_mess {
    margin-top: 37px;
    color: #555;
    .left_top_share {
      align-items: center;
      color: #c9c9c9;
    .share{
          .shareHover:hover {
            z-index: 99999;
        }
    }
      p {
        font-size: 12px !important;
        padding: 0;
        &:nth-last-of-type(1) {
          margin-left: 33px;
        }
        i{
          font-size: 22px;
          cursor: pointer;
        }
      }
    }
  }
  .details_right {
    padding-top: 35px;
    .recommendedRequirements {
      padding: 20px 22px 0;
      background: #fff;
      border-radius: 10px;
      .requirementsTitle {
        display: flex;
        justify-content: space-between;
        .name {
          font-size: 18px;
          font-weight: bold;
          color: #157efb;
        }
        .refresh {
          font-size: 12px;
          cursor: pointer;
          color: #262626;
          //   line-height: 20px;
          display: flex;
          align-items: center;
          i {
            font-size: 18px;
            margin-left: 2px;
          }
        }
      }
      .requirementItem {
        padding: 24px 0;
        border-bottom: 2px solid #f5f5f5;
        &:last-child {
          border-bottom: none;
        }
        .rqTitle {
          font-size: 16px;
          font-weight: normal;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 10px;
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .rqDetail {
          li {
            display: flex;
            padding-bottom: 8px;
            &:last-child {
              padding: 0;
            }
            .detailTitle {
              width: 70px;
              font-size: 13px;
              color: rgba(0, 0, 0, 0.85);
            }
            .detailContent {
              width: 240px;
              font-size: 13px;
              color: #808080;
            }
          }
        }
      }
    }
  }
}

.red {
  color: #d60000;
}

.details {
  width: 1200px;
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 24px;
  .details_left {
    width: 816px;
    margin-right: 21px;
    flex-shrink: 0;

    .left_top {
      background: #fff;
      border-radius: 10px;
      padding: 30px 42px 30px 29px;
      margin-bottom: 20px;

      .left_top_title {
        justify-content: space-between;
      }
    }

    /*基本信息*/

    .left_center {
      padding: 21px 31px;
      background: #ffffff;
      border-radius: 10px;
      margin-bottom: 20px;
      background: #fff;
      .center_mess {
        margin-bottom: 36px;

          //   display: flex;
          //   flex-wrap: wrap;
          .center_mess_box {
            // width: 50%;
            margin-top: 20px;
            .mess_box_details {
              margin-top: 10px;
              margin-left: 5px;
            }
          }
        .center_mess_box_img{
          /deep/ img{
            width: 100%!important;
          }
        }
        .center_mess_title {
          font-size: 18px;
          color: #262626;
          font-weight: bold;
          margin-left: 5px;
        }

        .center_mess_box {
          .mess_box_title {
            font-size: 16px;
            color: #262626;
            font-weight: bold;
            align-items: center;

            i {
              display: inline-block;
              width: 2px;
              height: 16px;
              background: #157efb;
              margin-right: 4px;
              position: relative;
              //   top: 2px;
            }
          }
          .mess_box_details {
            align-items: center;
            margin-top: 15px;
            margin-left: 5px;

            p {
              color: #000;
              font-size: 14px;
              line-height: 20px;
            }

            i {
              display: inline-block;
              width: 1px;
              height: 16px;
              background: #555;
              margin: 0 10px;
            }
          }

          .mess_box_text {
            color: #157efb;
            font-size: 14px;
            margin-top: 15px;
            margin-left: 5px;

            p {
              align-content: center;
              display: flex;
              line-height: 20px;
              i {
                font-size: 20px;
              }
            }
          }

          .mess_img {
            display: flex;
            align-items: center;
            margin-top: 14px;
          }
        }
      }
    }

    .left_bottom {
      font-size: 14px;
      color: #555;
      padding: 26px 36px;
      background: #fff;
      border-radius: 10px;
      /deep/.el-button--primary {
        background-color: #157efb;
        border-color: #157efb;
      }
      p {
        color: #000;
      }
      .left_bottom_title {
        font-size: 18px;
        font-weight: bold;
        color: #262626;
      }

      .bottom_input {
        margin-top: 10px;
        align-items: center;
        // font-size: 14px;
        .bottom_money {
          align-items: center;
          margin-right: 30px;

          input {
            border: 1px solid #ddd;
            border-radius: 5px;
            background: #fff;
            width: 108px;
            height: 30px;
            margin: 0 10px;
            padding-left: 10px;
          }
        }
      }

      .bottom_tex {
        margin-top: 10px;

        p {
          margin-right: 10px;
        }

        textarea {
          width: 80%;
          /*border: none;*/
          border-color: #ddd;
          background: #fff;
          border-radius: 5px;
          padding: 10px;
        }
      }

      .bottom_up {
        margin-top: 10px;

        align-items: flex-start;

        p {
          margin-right: 10px;
          margin-top: 6px;
        }

        .red {
          font-size: 12px;
        }
      }

      .upButton {
        margin-top: 30px;
        text-align: center;
        button {
          border: none;
          border-radius: 4px;
          height: 30px;
          width: 105px;
          background: linear-gradient(180deg, #4377fa 0%, #606aff 100%);
          color: #fff;
          font-size: 12px;
          cursor: pointer;
        }
      }
    }
  }

  .details_right {
    .right_mess {
      //   border: 1px solid #e3e3e3;
      border-radius: 4px;
      text-align: center;
      margin: 0 auto 20px;
      padding: 45px 0 20px;
      background: #fff;
      height: 197px;
      .firstImg img{
        width: 97px;
        height: 97px;
        border-radius: 50%;
        background: #efefef;
      }

      .right_mess_names {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
        color: #000;
        font-size: 18px;
      }

      .right_mess_design {
        font-size: 14px;
        color: #555;
        margin: 13px 0;
      }

      button {
        cursor: pointer;
        border: 1px solid #157efb;
        border-radius: 4px;
        background: #fff;
        font-size: 12px;
        width: 90px;
        height: 32px;
        margin: 30px 0 20px;
        color: #157efb;
      }
    }


  }
}
.mess_box_detailshtml {
  /deep/img {
    max-width: 100% !important;
  }
}
.ql-editor {
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/design/productWork.vue